import * as React from 'react';
import Footer from '../components/footer';
import Section1 from '../components/section-1';
import Section4 from '../components/section-4';
import Seo from '../components/seo';
import Layout from '../layouts/layout';
import Plans from '../components/plans';
import Section5 from '../components/section-5';
import Section2 from '../components/section-2';
import Section3 from '../components/section-3';

export default function IndexPage({location}) {
    return (
        <Layout location={location}>
            <Seo title="Home"/>
            {/*<Hero />*/}
            <div className="container mx-auto  ">
                <Section1/>
                <Section2/>
                <Section4/>
                <Section3/>
                <Section5/>
            </div>
            <Footer/>
        </Layout>
    );
}
